import { DEFAULT_STEP_COUNT, DEFAULT_STEP_DELAY, OFFSET_DESKTOP, OFFSET_MOBILE } from '@shared/const/animation.const'

let observer = null
let observerConfigKey = ''

function getRootMargin() {
  const bottomOffset = window.innerWidth > 1024 ? OFFSET_DESKTOP : OFFSET_MOBILE
  return `0px 0px -${bottomOffset}px 0px`
}

function getDelay(index, initialDelay, stepDelay, stepCount, shouldDelay) {
  if (!shouldDelay) return 0
  if (stepCount <= 0) return initialDelay + stepDelay

  return initialDelay + ((index % stepCount) + 1) * stepDelay
}

function createObserver({ initialDelay, stepDelay, stepCount }) {
  return new IntersectionObserver(
    entries => {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) return

        observer.unobserve(target)

        const index = Number(target.dataset.delayIndex || 0)
        const shouldDelay = target.dataset.delay === 'true'
        const timeout = getDelay(index, initialDelay, stepDelay, stepCount, shouldDelay)

        setTimeout(() => {
          target.dataset.animate = 'true'
          target.dataset.delay = 'false'
        }, timeout)
      })
    },
    {
      rootMargin: getRootMargin(),
    }
  )
}

export function initAnimateObserver(params = {}) {
  const configKey = JSON.stringify(params)

  if (observer && observerConfigKey === configKey) {
    return observer
  }

  observer?.disconnect()
  observer = createObserver(params)
  observerConfigKey = configKey

  return observer
}

export function observeNewAnimateBlocks(
  { initialDelay = 0, stepDelay = DEFAULT_STEP_DELAY, stepCount = DEFAULT_STEP_COUNT } = {},
  root = document
) {
  const blocks = root.querySelectorAll('[data-animate="false"]')
  const currentObserver = initAnimateObserver({ initialDelay, stepDelay, stepCount, nodeName: root?.nodeName })

  blocks.forEach((el, idx) => {
    if (!el.dataset.delayIndex) {
      el.dataset.delayIndex = String(idx)
    }

    currentObserver.observe(el)
  })
}



// WEBPACK FOOTER //
// ./src/modules/shared/utils/animate/scroll.animate.js